/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseConfigRecommendedSettings_ConfigFragmentDoc } from '../../../__generated__/useConfigRecommendedSettings.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UseConfigPowerToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, power?: { __typename: 'ConfigPowerState', reported: Types.ConfigPower, reportedAt: any } | null, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null };

export type ConfigUpdatePowerMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdatePowerInput;
}>;


export type ConfigUpdatePowerMutation = { __typename: 'Mutation', configurationUpdatePower: { __typename: 'ConfigurationModel', id: string, power?: { __typename: 'ConfigPowerState', reported: Types.ConfigPower, reportedAt: any } | null, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null } };

export const UseConfigPowerToggle_ConfigFragmentDoc = gql`
    fragment useConfigPowerToggle_config on ConfigurationModel {
  id
  power {
    reported
    reportedAt
  }
  ...UseConfigRecommendedSettings_config
}
    ${UseConfigRecommendedSettings_ConfigFragmentDoc}`;
export const ConfigUpdatePowerDocument = gql`
    mutation ConfigUpdatePower($input: ConfigurationUpdatePowerInput!) {
  configurationUpdatePower(input: $input) {
    id
    power {
      reported
      reportedAt
    }
    ...UseConfigRecommendedSettings_config
  }
}
    ${UseConfigRecommendedSettings_ConfigFragmentDoc}`;
export type ConfigUpdatePowerMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdatePowerMutation, ConfigUpdatePowerMutationVariables>;

/**
 * __useConfigUpdatePowerMutation__
 *
 * To run a mutation, you first call `useConfigUpdatePowerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdatePowerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdatePowerMutation, { data, loading, error }] = useConfigUpdatePowerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdatePowerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdatePowerMutation, ConfigUpdatePowerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdatePowerMutation, ConfigUpdatePowerMutationVariables>(ConfigUpdatePowerDocument, options);
      }
export type ConfigUpdatePowerMutationHookResult = ReturnType<typeof useConfigUpdatePowerMutation>;
export type ConfigUpdatePowerMutationResult = ApolloReactCommon.MutationResult<ConfigUpdatePowerMutation>;
export type ConfigUpdatePowerMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdatePowerMutation, ConfigUpdatePowerMutationVariables>;